<template>
  <modal-wrap
    :id="id"
    ref="integrationsDetails"
    :name="modalName"
    :header-class="'integrations-details-header'"
    body-class="integrations-details-modal"
    :hide-footer="true"
    size="sm"
  >
    <template #modal-title>
      <div class="d-flex justify-content-between align-items-center">
        <h4>{{ modalTitle }}</h4>
      </div>
    </template>
    <template #default>
      <div v-if="modalData?.marketplace === ONGOING">
        <b>Webhook URL:</b> {{ ongoingWebhooksUrl }}
        <CopyToClipboard :text="ongoingWebhooksUrl"><button class="fa-copy fa" title="Copy" /></CopyToClipboard><br />

        <br />

        <div class="d-flex justify-content-between align-items-center">
          <b>Distribution Channel</b>
        </div>
        <div class="row">
          <div class="form-group mb-0 col-3">
            <input
              :id="'type_package'"
              v-model="channel"
              :checked="channel === 'package'"
              value="package"
              name="distribution_channel"
              type="radio"
            />
            <label :for="'type_package'" class="radio-group ongoing">
              <span class="radio-description">Package</span>
            </label>
          </div>
          <div class="form-group mb-0 col-3">
            <input
              :id="'type_parcel'"
              v-model="channel"
              :checked="channel === 'parcel'"
              value="parcel"
              name="distribution_channel"
              type="radio"
            />
            <label :for="'type_parcel'" class="radio-group ongoing">
              <span class="radio-description">Parcel</span>
            </label>
          </div>
        </div>

        <br />

        <div class="row">
          <div class="form-group mb-0">
            <div class="form-check mb-0 mt-0">
              <input
                id="sandbox"
                v-model="payloadOngoing.credentials.sandbox"
                class="form-check-input"
                type="checkbox"
              />
              <label for="sandbox" class="form-check-label mb-0"> Sandbox </label>
            </div>
          </div>
        </div>

        <br />

        <div class="d-flex justify-content-between align-items-center">
          <b>Status Settings</b>
        </div>

        <div class="row">
          <div class="form-group mb-0">
            <div class="form-check mb-0 mt-0">
              <input
                id="updateLabel"
                v-model="payloadOngoing.configuration.updateLabel"
                class="form-check-input"
                type="checkbox"
              />
              <label for="updateLabel" class="form-check-label mb-0"> Send Labels to OnGoing </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group">
            <div class="form-check mb-0 mt-0">
              <input
                id="sendLabels"
                v-model="payloadOngoing.configuration.updateStatus"
                class="form-check-input"
                type="checkbox"
              />
              <label for="sendLabels" class="form-check-label"> Send Status to OnGoing </label>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <b>Status for error</b>
        </div>

        <div class="row">
          <div class="form-group">
            <div class="input-group">
              <select v-model="payloadOngoing.configuration.onErrorStatusCode" class="form-control">
                <option v-for="(status, key) in ongoingStatuses" :key="key" :value="status.number">
                  {{ status.text }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <b>Status for success</b>
        </div>

        <div class="row">
          <div class="form-group">
            <div class="input-group">
              <select v-model="payloadOngoing.configuration.onSuccessStatusCode" class="form-control">
                <option v-for="(status, key) in ongoingStatuses" :key="key" :value="status.number">
                  {{ status.text }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <b>Packaging Weight</b>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="form-check mb-0 mt-0">
                <input
                  id="ongoingPackagingWeightEnabled"
                  v-model="payloadOngoing.configuration.packagingWeightEnabled"
                  class="form-check-input"
                  type="checkbox"
                />
                <label for="ongoingPackagingWeightEnabled" class="form-check-label"> Include packaging weight </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Packaging Weight (g)</label>
              <VInput
                v-model="payloadOngoing.configuration.packagingWeight"
                type="text"
                name="ongoingPackagingWeight"
                :formatter="numbersOnly"
                :disabled="!payloadOngoing.configuration.packagingWeightEnabled"
                :rules="packagingWeightRules(payloadOngoing.configuration.packagingWeightEnabled)"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <button type="button" class="btn create-btn btn-green" @click="viewOrders(modalData.id)">
                View Orders
              </button>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group text-right">
              <button type="button" class="btn create-btn btn-green" @click="updateSettings()">Save Settings</button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="modalData?.marketplace === SHOPIFY">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label><b>Shop: </b></label>
              {{ payloadShopify.credentials.url }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group">
            <div class="form-check mb-0 mt-0">
              <input
                id="sendLabels"
                v-model="payloadShopify.configuration.updateLabel"
                class="form-check-input"
                type="checkbox"
              />
              <label for="sendLabels" class="form-check-label"> Send Label to Shopify </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group">
            <div class="form-check mb-0 mt-0">
              <input
                id="onlyPaid"
                v-model="payloadShopify.configuration.onlyPaid"
                class="form-check-input"
                type="checkbox"
              />
              <label for="onlyPaid" class="form-check-label"> Require paid order before label creation </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Error Report Email</label>
              <VInput
                v-model="payloadShopify.configuration.reportEmail"
                type="text"
                name="key"
                :rules="{ email: true }"
                placeholder="..."
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="form-check mb-0 mt-0">
                <input
                  id="shopifyPackagingWeightEnabled"
                  v-model="payloadShopify.configuration.packagingWeightEnabled"
                  class="form-check-input"
                  type="checkbox"
                />
                <label for="shopifyPackagingWeightEnabled" class="form-check-label"> Include packaging weight </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Packaging Weight (g)</label>
              <VInput
                v-model="payloadShopify.configuration.packagingWeight"
                type="text"
                name="shopifyPackagingWeight"
                :formatter="numbersOnly"
                :disabled="!payloadShopify.configuration.packagingWeightEnabled"
                :rules="packagingWeightRules(payloadShopify.configuration.packagingWeightEnabled)"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <button type="button" class="btn create-btn btn-green" @click="viewOrders(modalData.id)">
                View Orders
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group text-center">
              <button type="button" class="btn create-btn btn-green" @click="updateSettings()">Save Settings</button>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group text-right">
              <button type="button" class="btn create-btn btn-green" @click="syncSettings(modalData.id)">
                Sync Settings
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="modalData?.marketplace === WOOCOMMERCE">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              WebhookURL: {{ webhooksUrl }}
              <CopyToClipboard :text="webhooksUrl"><button class="fa-copy fa" title="Copy" /></CopyToClipboard>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Url: {{ modalData.credentials.url }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="wc-details-trigger-order-status"><b>Trigger Order Status</b></label>
              <select
                id="wc-details-trigger-order-status"
                v-model="payloadWooCommerce.configuration.triggerOrderStatus"
                class="form-control"
              >
                <option value="completed">Completed</option>
                <option value="processing">Processing</option>
                <option value="on-hold">On Hold</option>
                <option value="pending">Pending</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="form-check mb-0 mt-0">
                <input
                  id="wooPackagingWeightEnabled"
                  v-model="payloadWooCommerce.configuration.packagingWeightEnabled"
                  class="form-check-input"
                  type="checkbox"
                />
                <label for="wooPackagingWeightEnabled" class="form-check-label"> Include packaging weight </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Packaging Weight (g)</label>
              <VInput
                v-model="payloadWooCommerce.configuration.packagingWeight"
                type="text"
                name="wooPackagingWeight"
                :formatter="numbersOnly"
                :disabled="!payloadWooCommerce.configuration.packagingWeightEnabled"
                :rules="packagingWeightRules(payloadWooCommerce.configuration.packagingWeightEnabled)"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Weight: {{ modalData.default_weight }}g</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Height: {{ modalData.default_height }}cm</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Width: {{ modalData.default_width }}cm</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Length: {{ modalData.default_length }}cm</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Active: {{ modalData.active ? 'Yes' : 'No' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Interval: every {{ modalData.import_interval || 60 }} minutes</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              Import Type:
              {{ modalData.import_type.replace(/\_/, ' ') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              Last Imported:
              {{ modalData.last_imported_at ? modalData.last_imported_at : 'no data' }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <button type="button" class="btn create-btn btn-green" @click="viewOrders(modalData.id)">
                View Orders
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group text-center">
              <button type="button" class="btn create-btn btn-green" @click="updateSettings()">Save Settings</button>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group text-right">
              <button type="button" class="btn create-btn btn-green" @click="runImport(modalData.id)">
                Run import
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <button type="button" class="btn create-btn btn-green" @click="syncSettings(modalData.id)">
                Sync Settings
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="modalData?.marketplace === MAGENTO">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Url: {{ modalData.credentials.url }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Weight: {{ modalData.default_weight }}g</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Height: {{ modalData.default_height }}cm</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Height: {{ modalData.default_width }}cm</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Default Height: {{ modalData.default_length }}cm</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Active: {{ modalData.active ? 'Yes' : 'No' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">Interval: every {{ modalData.import_interval || 60 }} minutes</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              Import Type:
              {{ modalData.import_type.replace(/\_/, ' ') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              Last Imported:
              {{ modalData.last_imported_at ? modalData.last_imported_at : 'no data' }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <button type="button" class="btn create-btn btn-green" @click="viewOrders(modalData.id)">
                View Orders
              </button>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group text-right">
              <button type="button" class="btn create-btn btn-green" @click="runImport(modalData.id)">
                Run import
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="modalData?.marketplace === VISKAN">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Import Type</label>
              <div class="row">
                <div class="col-12 col-md-12">
                  <input id="viskan_scheduled" v-model="payloadViskan.import_type" type="radio" value="scheduled" />
                  <label for="viskan_scheduled" class="radio-group">
                    <span class="radio-title">Scheduled</span>
                  </label>
                </div>
                <div class="col-12 col-md-12">
                  <input id="viskan_on_demand" v-model="payloadViskan.import_type" type="radio" value="on_demand" />
                  <label for="viskan_on_demand" class="radio-group">
                    <span class="radio-title">On Demand</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Interval (minutes)</label>
              <VInput
                v-model="payloadViskan.import_interval"
                type="text"
                name="import_interval"
                :formatter="numbersOnly"
                :rules="{ required: true, min: 1 }"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Default Weight (g)</label>
              <VInput
                v-model="payloadViskan.default_weight"
                type="text"
                name="defaultWeight"
                :formatter="numbersOnly"
                :rules="{ required: true, min: 1 }"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Default Height (cm)</label>
              <VInput
                v-model="payloadViskan.default_height"
                type="text"
                name="defaultHeight"
                :formatter="numbersOnly"
                :rules="{ required: true, min: 1 }"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Default Width (cm)</label>
              <VInput
                v-model="payloadViskan.default_width"
                type="text"
                name="defaultWidth"
                :formatter="numbersOnly"
                :rules="{ required: true, min: 1 }"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Default Length (cm)</label>
              <VInput
                v-model="payloadViskan.default_length"
                type="text"
                name="defaultLength"
                :formatter="numbersOnly"
                :rules="{ required: true, min: 1 }"
              />
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3">
          <h5 class="mb-0">Fallback Configuration</h5>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3">
          <h5 class="mb-0">Packaging Weight</h5>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="form-check mb-0 mt-0">
                <input
                  id="viskanPackagingWeightEnabled"
                  v-model="payloadViskan.configuration.packagingWeightEnabled"
                  class="form-check-input"
                  type="checkbox"
                />
                <label for="viskanPackagingWeightEnabled" class="form-check-label"> Include packaging weight </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Packaging Weight (g)</label>
              <VInput
                v-model="payloadViskan.configuration.packagingWeight"
                type="text"
                name="viskanPackagingWeight"
                :formatter="numbersOnly"
                :disabled="!payloadViskan.configuration.packagingWeightEnabled"
                :rules="packagingWeightRules(payloadViskan.configuration.packagingWeightEnabled)"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Distribution Channel</label>
              <select v-model="payloadViskan.configuration.fallbackDistributionChannel" class="form-control">
                <option :value="null">— None —</option>
                <option value="parcel">Parcel</option>
                <option value="package">Package</option>
                <option value="letter">Letter</option>
                <option value="box">Box</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Service Level</label>
              <select v-model="payloadViskan.configuration.fallbackServiceLevel" class="form-control">
                <option :value="null">— None —</option>
                <option value="economy">Economy</option>
                <option value="priority">Priority</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Fallback Phone</label>
              <VInput
                v-model="payloadViskan.configuration.fallbackPhone"
                type="text"
                name="fallbackPhone"
                placeholder="Fallback phone number"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Fallback Email</label>
              <VInput
                v-model="payloadViskan.configuration.fallbackEmail"
                type="text"
                name="fallbackEmail"
                placeholder="Fallback email address"
              />
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3">
          <h5 class="mb-0">Delivery Method Mapping</h5>
          <button type="button" class="btn btn-sm create-btn btn-green" @click="addMappingRow">+ Add</button>
        </div>

        <div v-if="mappingRows.length" class="mt-2">
          <div class="row fw-bold mb-1">
            <div class="col-md-4">Method Name</div>
            <div class="col-md-3">Channel</div>
            <div class="col-md-3">Service Level</div>
            <div class="col-md-2"></div>
          </div>
          <div v-for="row in mappingRows" :key="row.methodName" class="row mb-1 align-items-center">
            <div class="col-md-4">
              <input
                :value="row.methodName"
                type="text"
                class="form-control form-control-sm"
                @blur="(e) => updateMappingRow(row.methodName, 'methodName', (e.target as HTMLInputElement).value)"
              />
            </div>
            <div class="col-md-3">
              <select
                :value="row.distributionChannel"
                class="form-control form-control-sm"
                @change="
                  (e) => updateMappingRow(row.methodName, 'distributionChannel', (e.target as HTMLSelectElement).value)
                "
              >
                <option value="package">Package</option>
                <option value="parcel">Parcel</option>
                <option value="letter">Letter</option>
                <option value="box">Box</option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                :value="row.serviceLevel"
                class="form-control form-control-sm"
                @change="(e) => updateMappingRow(row.methodName, 'serviceLevel', (e.target as HTMLSelectElement).value)"
              >
                <option value="economy">Economy</option>
                <option value="priority">Priority</option>
              </select>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-sm btn-danger" @click="removeMappingRow(row.methodName)">✕</button>
            </div>
          </div>
        </div>
        <div v-else class="text-muted mt-1 mb-2">No mappings configured — defaults will be used.</div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Active: {{ modalData.active ? 'Yes' : 'No' }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              Last Imported: {{ modalData.last_imported_at ? modalData.last_imported_at : 'no data' }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <button type="button" class="btn create-btn btn-green" @click="viewOrders(modalData.id)">
                View Orders
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group text-center">
              <button type="button" class="btn create-btn btn-green" @click="runImport(modalData.id)">
                Run Import
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group text-right">
              <button type="button" class="btn create-btn btn-green" @click="updateSettings()">Save Settings</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </modal-wrap>
</template>

<script lang="ts">
import type {
  Integration,
  OngoingPayload,
  OngoingStatuses,
  ShopifyPayload,
  ViskanPayload,
  WooCommercePayload,
} from '@/types/Models/Integration'
import { notify } from '@kyvg/vue3-notification'
import { defineComponent, computed, ref, watch, type Ref, type ComputedRef } from 'vue'
import { MAGENTO, ONGOING, SHOPIFY, VISKAN, WOOCOMMERCE } from '@/const/IntegrationTypes'
import { INTEGRATION_DETAILS, INTEGRATION_ORDERS } from '@/const/ModalTypes'
import { getSystemDisplayName, numbersOnly } from '@/services/Helpers'
import { openModal } from '@/services/Modal'
import { useCustomersIntegrationsStore } from '@/store/customers/integrations'
import { useVueNextModalStore } from '@/store/vueNextModal'
import VInput from '@/views/Components/Elements/Form/VInput.vue'
import ModalWrap from '@/views/Modals/ModalWrap.vue'
import CopyToClipboard from '@/views/Components/Elements/CopyToClipboard.vue'

export default defineComponent({
  name: 'IntegrationsDetailsModal',
  components: { VInput, CopyToClipboard, ModalWrap },
  props: {
    id: { type: String, required: true },
  },
  setup() {
    const modalStore = useVueNextModalStore()
    const customersIntegrationsStore = useCustomersIntegrationsStore()

    const modalName = INTEGRATION_DETAILS
    const modalData: ComputedRef<Integration> = computed(() => modalStore.modalPropsByName(modalName))
    const importUrl: string = import.meta.env.VITE_APP_INTEGRATION_URL
    const modalTitle: ComputedRef<string> = computed(
      () => `Integration details for ${getSystemDisplayName(modalData.value?.marketplace)}`,
    )
    const customerId: ComputedRef<string> = computed(() => modalStore.modalPropsByName(modalName)?.customerId)
    const webhooksUrl: ComputedRef<string> = computed(
      () => `${importUrl}/webhook/woocommerce?client_internal_id=${modalData.value?.client_internal_id}`,
    )
    const ongoingWebhooksUrl: ComputedRef<string> = computed(
      () =>
        `${importUrl}/webhook/ongoing?client_internal_id=${modalData.value?.client_internal_id}&distributionChannel=${channel.value}`,
    )
    const ongoingStatuses: ComputedRef<OngoingStatuses[]> = computed(() => customersIntegrationsStore.ongoingStatuses)

    const channel: Ref<string> = ref('package')
    const payloadOngoing: Ref<OngoingPayload> = ref({
      marketplace: ONGOING,
      configuration: {
        onErrorStatusCode: 150,
        onSuccessStatusCode: 350,
        updateStatus: false,
        updateLabel: false,
        packagingWeightEnabled: false,
        packagingWeight: 0,
      },
      credentials: {
        sandbox: false,
      },
    })
    const payloadShopify: Ref<ShopifyPayload> = ref({
      marketplace: SHOPIFY,
      credentials: {
        url: '',
      },
      configuration: {
        updateLabel: false,
        onlyPaid: false,
        reportEmail: '',
        packagingWeightEnabled: false,
        packagingWeight: 0,
      },
    })
    const payloadViskan: Ref<ViskanPayload> = ref({
      marketplace: VISKAN,
      import_type: 'scheduled',
      import_interval: 60,
      default_weight: 1000,
      default_height: 10,
      default_width: 10,
      default_length: 10,
      configuration: {
        fallbackDistributionChannel: 'package',
        fallbackServiceLevel: 'priority',
        fallbackPhone: null,
        fallbackEmail: null,
        deliveryMethodMapping: {},
        packagingWeightEnabled: false,
        packagingWeight: 0,
      },
    })
    const payloadWooCommerce: Ref<WooCommercePayload> = ref({
      marketplace: WOOCOMMERCE,
      configuration: {
        triggerOrderStatus: 'completed',
        packagingWeightEnabled: false,
        packagingWeight: 0,
      },
    })

    // Convert object mapping { methodName: { channel, level } } to array for table rendering
    const mappingRows = computed(() => {
      const mapping = payloadViskan.value.configuration.deliveryMethodMapping || {}
      return Object.entries(mapping).map(([methodName, entry]) => ({
        methodName,
        distributionChannel: entry.distributionChannel,
        serviceLevel: entry.serviceLevel,
      }))
    })

    const addMappingRow = () => {
      payloadViskan.value.configuration.deliveryMethodMapping = customersIntegrationsStore.addDeliveryMethodMapping(
        payloadViskan.value.configuration.deliveryMethodMapping,
      )
    }

    const removeMappingRow = (methodName: string) => {
      payloadViskan.value.configuration.deliveryMethodMapping = customersIntegrationsStore.removeDeliveryMethodMapping(
        payloadViskan.value.configuration.deliveryMethodMapping,
        methodName,
      )
    }

    const updateMappingRow = (oldName: string, field: string, value: string) => {
      payloadViskan.value.configuration.deliveryMethodMapping = customersIntegrationsStore.updateDeliveryMethodMapping(
        payloadViskan.value.configuration.deliveryMethodMapping,
        oldName,
        field,
        value,
      )
    }

    const updateSettings = () => {
      if (![SHOPIFY, ONGOING, VISKAN, WOOCOMMERCE].includes(modalData.value.marketplace)) return
      let params: ShopifyPayload | OngoingPayload | ViskanPayload | WooCommercePayload
      switch (modalData.value.marketplace) {
        case SHOPIFY:
          params = payloadShopify.value
          break
        case VISKAN:
          params = {
            ...payloadViskan.value,
            configuration: {
              ...payloadViskan.value.configuration,
              fallbackPhone: payloadViskan.value.configuration.fallbackPhone || null,
              fallbackEmail: payloadViskan.value.configuration.fallbackEmail || null,
              deliveryMethodMapping: payloadViskan.value.configuration.deliveryMethodMapping || {},
            },
          }
          break
        case WOOCOMMERCE:
          params = payloadWooCommerce.value
          break
        default:
          params = payloadOngoing.value
      }
      if (!isPackagingWeightValid(params.configuration)) return

      customersIntegrationsStore
        .updateSettings({
          customerId: customerId.value,
          integrationId: modalData.value.id,
          params,
        })
        .then((response) => {
          if (!response) return
          notify({ group: 'success', text: 'Settings have been updated' })
          modalStore.closeModal(modalName)
        })
    }

    const packagingWeightRules = (enabled: boolean) =>
      enabled ? { required: true, integer: true, min_value: 1 } : {}

    const isPackagingWeightValid = (configuration: Integration['configuration']) => {
      if (!configuration.packagingWeightEnabled) return true

      const weight = Number(configuration.packagingWeight)
      return Number.isInteger(weight) && weight > 0
    }

    const runImport = (id: string) => {
      customersIntegrationsStore.forceImport({ id, customerId: customerId.value, params: {} }).then((response) => {
        if (!response) return
        notify({ group: 'success', text: 'Import started' })
      })
    }

    const syncSettings = (id: string) => {
      customersIntegrationsStore.syncSettings({ id, customerId: customerId.value }).then((response) => {
        if (!response) return
        notify({ group: 'success', text: 'Settings synchronized successfully' })
      })
    }

    const viewOrders = (id: string) => {
      openModal(INTEGRATION_ORDERS, {
        customerId: customerId.value,
        integrationId: id,
        type: modalData.value.marketplace,
      })
    }

    watch(
      () => modalData.value,
      () => {
        if (!modalData.value.id) return
        if (modalData.value.marketplace === ONGOING) {
          customersIntegrationsStore
            .fetchStatuses({ customerId: customerId.value, id: modalData.value.id })
            .then(() => {
              payloadOngoing.value.configuration.onErrorStatusCode =
                modalData.value?.configuration?.onErrorStatusCode || 150
              payloadOngoing.value.configuration.onSuccessStatusCode =
                modalData.value?.configuration?.onSuccessStatusCode || 350
              payloadOngoing.value.configuration.updateStatus = modalData.value?.configuration?.updateStatus || false
              payloadOngoing.value.configuration.updateLabel = modalData.value?.configuration?.updateLabel || false
              payloadOngoing.value.configuration.packagingWeightEnabled = Boolean(
                modalData.value?.configuration?.packagingWeightEnabled || false,
              )
              payloadOngoing.value.configuration.packagingWeight = modalData.value?.configuration?.packagingWeight || 0
            })
        }
        if (modalData.value.marketplace === SHOPIFY) {
          payloadShopify.value.credentials.url = modalData.value?.credentials?.url || ''
          payloadShopify.value.configuration.updateLabel = Boolean(modalData.value?.configuration?.updateLabel || false)
          payloadShopify.value.configuration.onlyPaid = Boolean(modalData.value?.configuration?.onlyPaid || false)
          payloadShopify.value.configuration.reportEmail = modalData.value?.configuration?.reportEmail || ''
          payloadShopify.value.configuration.packagingWeightEnabled = Boolean(
            modalData.value?.configuration?.packagingWeightEnabled || false,
          )
          payloadShopify.value.configuration.packagingWeight = modalData.value?.configuration?.packagingWeight || 0
        }
        if (modalData.value.marketplace === VISKAN) {
          payloadViskan.value.import_type = (modalData.value?.import_type as 'scheduled' | 'on_demand') || 'scheduled'
          payloadViskan.value.import_interval = modalData.value?.import_interval || 60
          payloadViskan.value.default_weight = modalData.value?.default_weight || 1000
          payloadViskan.value.default_height = modalData.value?.default_height || 10
          payloadViskan.value.default_width = modalData.value?.default_width || 10
          payloadViskan.value.default_length = modalData.value?.default_length || 10
          payloadViskan.value.configuration.fallbackDistributionChannel =
            modalData.value?.configuration?.fallbackDistributionChannel || 'package'
          payloadViskan.value.configuration.fallbackServiceLevel =
            modalData.value?.configuration?.fallbackServiceLevel || 'priority'
          payloadViskan.value.configuration.fallbackPhone = modalData.value?.configuration?.fallbackPhone || null
          payloadViskan.value.configuration.fallbackEmail = modalData.value?.configuration?.fallbackEmail || null
          payloadViskan.value.configuration.deliveryMethodMapping =
            modalData.value?.configuration?.deliveryMethodMapping || {}
          payloadViskan.value.configuration.packagingWeightEnabled = Boolean(
            modalData.value?.configuration?.packagingWeightEnabled || false,
          )
          payloadViskan.value.configuration.packagingWeight = modalData.value?.configuration?.packagingWeight || 0
        }
        if (modalData.value.marketplace === WOOCOMMERCE) {
          payloadWooCommerce.value.configuration.triggerOrderStatus =
            modalData.value?.configuration?.triggerOrderStatus || 'completed'
          payloadWooCommerce.value.configuration.packagingWeightEnabled = Boolean(
            modalData.value?.configuration?.packagingWeightEnabled || false,
          )
          payloadWooCommerce.value.configuration.packagingWeight = modalData.value?.configuration?.packagingWeight || 0
        }
      },
      { deep: true },
    )

    return {
      channel,
      modalName,
      modalData,
      modalTitle,
      customerId,
      webhooksUrl,
      payloadOngoing,
      payloadShopify,
      payloadViskan,
      payloadWooCommerce,
      ongoingStatuses,
      ongoingWebhooksUrl,
      numbersOnly,
      packagingWeightRules,
      updateSettings,
      viewOrders,
      runImport,
      syncSettings,
      SHOPIFY,
      ONGOING,
      MAGENTO,
      VISKAN,
      WOOCOMMERCE,
      mappingRows,
      addMappingRow,
      removeMappingRow,
      updateMappingRow,
    }
  },
})
</script>
